import React, { useEffect } from 'react';
import { Select as AntdSelect } from 'antd';
import PropTypes from 'prop-types';
import WithSelectCreatable from './WithSelectCreatable';

const SelectCreatable = WithSelectCreatable(AntdSelect);

function Select(props) {
  const { value, options, creatable, onCreate, ...rest } = props;
  const [_options, setOptions] = React.useState(options);

  const handleCreate = (newOption) => {
    setOptions([..._options, newOption]);
    if (onCreate) {
      onCreate(newOption, {
        ...props,
      });
    }
  };

  useEffect(() => {
    setOptions([...options]);
  }, [options]);

  return (
    <SelectCreatable
      value={value}
      options={_options}
      onCreate={handleCreate}
      creatable={creatable}
      {...rest}
    />
  );
}

Select.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  mode: PropTypes.oneOf(['multiple', 'tags', null, undefined]),
  creatable: PropTypes.bool,
  /**
   * Handles the creation of a new option.
   *
   * @param {Object} newOption - The new option to be created.
   * @returns {Error|undefined} Returns an error if the new option is not provided.
   */
  onCreate(newOption) {
    if (!newOption) {
      throw new Error("Error: 'onCreate' prop is required");
    }
  },
};

Select.defaultProps = {
  value: null,
  mode: null,
  creatable: false,
  onCreate: null,
};

export default Select;
